import React, { useMemo, useState } from 'react';
import { OptionKey } from '@common-fe/common-fe';

import { OrganizationTypes } from '@/common/constants';
import { useCurrentOrganization } from '@/modules/core/hooks';

import { useGetReplenishmentStatisticQuery } from '../../Statistics/ReplenishmentStatistic/queries';

import { BannerReplenishmentPreview } from './components';

const BannerReplenishmentPreviewContainer: React.FC = () => {
  const [currentPlan, setCurrentPlan] = useState<OptionKey>('');
  const [currentSubsidiary, setCurrentSubsidiary] = useState<OptionKey>('');

  const {
    observingOrganization: { type },
  } = useCurrentOrganization();

  const isAvailable = useMemo(
    () =>
      type === OrganizationTypes.employer ||
      type === OrganizationTypes.company ||
      type === OrganizationTypes.subsidiary,
    [type]
  );

  const { data, isLoading, planIds } = useGetReplenishmentStatisticQuery({
    date: new Date(),
    planId: currentPlan as string,
    subsidiaryId: currentSubsidiary as string,
    futureDates: [],
  });

  if (!isAvailable) {
    return null;
  }

  return (
    <BannerReplenishmentPreview
      isLoading={isLoading}
      data={data}
      planIds={planIds}
      planValue={currentPlan}
      onSetPlanValue={setCurrentPlan}
      subsidiaryValue={currentSubsidiary}
      onSetSubsidiaryValue={setCurrentSubsidiary}
    />
  );
};

export default BannerReplenishmentPreviewContainer;
